export const MAX_LENGTH_SHOP_NAME = 10;

export const DB_DATE_FORMAT = 'YYYY-MM-DD';
export const CHART_DATE_FORMAT = 'D/MM';
export const TABLE_DATE_FORMAT = 'MMM DD, YYYY';
export const DETECT_CODE_DATE_FORMAT = 'YYYY-MM-DD HH:MM';
export const LAST_CHECK_DATE_FORMAT = 'DD-MM-YYYY HH:mm';
